var _excluded = ["text", "className", "skin", "placement"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, oneOf } from 'prop-types';
import classNames from 'classnames';
import './Tooltip.scss';
var propTypes = {
  /** The text inside the tooltip */
  text: string.isRequired,

  /** Add your own custom class names to the component */
  className: string,

  /** Add your own custom id to the component */
  id: string,

  /** Background color */
  skin: oneOf(['white', 'dark']),

  /** Placement of the tooltip relative to its reference */
  placement: oneOf(['top', 'right', 'bottom', 'left'])
};
var defaultProps = {
  skin: 'white',
  placement: 'top'
};
/**
 * A tooltip is a pattern used to show brief, helpful information that is related to a particular element.
 * It contains a single line of text, and can be attached to any element.
 * */

var Tooltip = function Tooltip(_ref) {
  var text = _ref.text,
      className = _ref.className,
      skin = _ref.skin,
      placement = _ref.placement,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-tooltip', {
    'rds-tooltip--placement-top': placement === 'top',
    'rds-tooltip--placement-right': placement === 'right',
    'rds-tooltip--placement-bottom': placement === 'bottom',
    'rds-tooltip--placement-left': placement === 'left',
    'rds-tooltip--white': skin === 'white',
    'rds-tooltip--dark': skin === 'dark'
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: componentClassNames,
    role: "tooltip"
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: 'rds-tooltip__content'
  }, " ", text, " "));
};

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
export default Tooltip;